import { Center } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useTitle } from 'react-use'
import { Container } from '../../common/components/Container'
import { TextLink } from '../../common/components/TextLink'
import { Title } from '../components/Title'

const PasswordChangeComplete: FC = () => {
  const [t] = useTranslation()
  useTitle(t('SEPAS パスワード変更'))

  return (
    <Container innerWidth={'800px'}>
      <Title text={t('パスワード変更')} />
      <div className={'mt24'}>
        {t('パスワード変更が完了しました。')}
        <br />
        {t('トップページからログインしてください。')}
      </div>
      <div className={'mt24'}>
        <Center className={'mt8'}>
          <TextLink text={t('トップページへ戻る')} to={'/'} />
        </Center>
      </div>
    </Container>
  )
}

export default PasswordChangeComplete
